// extracted by mini-css-extract-plugin
module.exports = {"faCheck":"snackbarNotify_faCheck__sMloK","snackbar":"snackbarNotify_snackbar__2vx5P","error":"snackbarNotify_error__vEnuM"};